export default __webpack_public_path__ + "static/media/classicV2-desktop.77781492.jpg";